<template>
  <Wrap class="author">
    <Author />
  </Wrap>
</template>

<script lang="ts" setup>
  import { Author } from '@/pages/author/features/author';
  import Wrap from '@/shared/ui/Wrap.vue';
</script>

<style lang="scss" scoped>
  .author {
    margin-top: var(--alias-space-40);
  }
</style>
